// extracted by mini-css-extract-plugin
export default {"wrapper":"lo-z","response":"mo-z","error":"no-z","disabled":"oo-z","buttons":"po-z","feedbackQuestionSection":"qo-z","yesNoWrapper":"ro-z"};